<div class="counter">
  <div class="counter__background"></div>
  <h3 class="counter__label">{{ label }}</h3>
  <div
    class="counter__values"
    [ngClass]="resultLength >= 8 ? 'counter__values--8' : resultLength >= 7 ? 'counter__values--7' : 'counter__values--6'"
  >
    <div *ngIf="resultLength >= 8" class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[0] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[0] }}</span>
      </ng-container>
    </div>
    <div *ngIf="resultLength >= 7" class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[1] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[1] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[2] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[2] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[3] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[3] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[4] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[4] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[5] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[5] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[6] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[6] }}</span>
      </ng-container>
    </div>
    <div class="counter__value">
      <ng-container *ngFor="let d of availableDigits">
        <span *ngIf="digits[7] === d" [@digit]="animationParameters" class="counter__value--digit">{{ digits[7] }}</span>
      </ng-container>
    </div>
    <div *ngIf="isBadgeVisible" class="counter__badge">
      <div class="counter__badge--inner">
        <p class="counter__badge--equals">=</p>
        <p class="counter__badge--number">{{ badgeNumber }}</p>
        <p class="counter__badge--text">{{ badgeLabel }}</p>
      </div>
    </div>
  </div>
</div>
